export default __webpack_public_path__ + "static/media/messi-profile-picture2.1eddc654.png";